import { Link } from 'react-router-dom';
import Menu from '../menu/menu';
import { logo } from '../../../assets';

const Header = () => {
  return (
    <>
      <Menu />
      <div className="flex items-center justify-between">
        <Link to="/">
          <img
            className="fixed sm:top-20 top-[4.7rem]
            left-[10vw] w-11 h-11 object-contain
            sm:opacity-[0.8] opacity-[0.6]"
            src={logo}
            alt="logo"
          />
        </Link>
        <p
          className="fixed z-11 top-20 right-[10vw] max-w-xs 
        transition-transform transition-delay-500 uppercase
        font-normal font-poppins sm:text-[16px] text-[13px]
        text-right sm:opacity-[0.8] opacity-[0.6]">
          Software Developer <br /> Portfolio
        </p>
      </div>
    </>
  );
};

export default Header;
